var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"px-10 py-11"},[_c('w-button',{staticClass:"prev-page",attrs:{"type":"text"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"icon-chevron-left-bold"}),_vm._v(" 返回一起訂東西 ")]),_c('order-overview',{staticClass:"mt-6",attrs:{"order-id":_vm.orderId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }